/**
 * Persist intended /client-portal/* destination across explicit sign-in
 * so deep links (project, tab, file) return after login.
 * Open-redirect safe: only internal client-portal paths.
 */

const STORAGE_KEY = "markbeattie_portalPostLoginReturn";

function safeStr(value) {
  return String(value ?? "").trim();
}

/**
 * Allow only same-origin portal paths. Reject protocol-relative, absolute URLs,
 * and non-portal routes.
 */
export function sanitizePortalReturnPath(pathWithSearchHash = "") {
  const raw = safeStr(pathWithSearchHash);
  if (!raw) return "";
  if (/^[a-z][a-z0-9+.-]*:/i.test(raw)) return "";
  if (raw.startsWith("//")) return "";
  if (!raw.startsWith("/")) return "";
  if (!raw.startsWith("/client-portal")) return "";
  if (raw.startsWith("/client-portal/../") || raw.includes("/../")) return "";
  // Normalize to pathname + search + hash only
  try {
    const u = new URL(raw, "https://markbeattie.invalid");
    if (u.pathname !== "/client-portal" && !u.pathname.startsWith("/client-portal/")) return "";
    return `${u.pathname}${u.search || ""}${u.hash || ""}`;
  } catch {
    return "";
  }
}

export function buildPortalReturnPathFromLocation(location = {}) {
  const pathname = safeStr(location.pathname);
  const search = safeStr(location.search);
  const hash = safeStr(location.hash);
  return sanitizePortalReturnPath(`${pathname}${search}${hash}`);
}

export function storePortalReturnPath(pathWithSearchHash) {
  const ok = sanitizePortalReturnPath(pathWithSearchHash);
  if (!ok) return "";
  try {
    sessionStorage.setItem(STORAGE_KEY, ok);
  } catch {
    // ignore
  }
  return ok;
}

export function peekPortalReturnPath() {
  try {
    return sanitizePortalReturnPath(sessionStorage.getItem(STORAGE_KEY) || "");
  } catch {
    return "";
  }
}

export function consumePortalReturnPath() {
  const v = peekPortalReturnPath();
  if (!v) return "";
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  return v;
}

export function clearPortalReturnPath() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
